import http, { url } from '../../http'

const API_URL = "revised_objectives_sgosh"

class revised_objetivesAPI {

  async save(objetives) {
    const response = await http(`${API_URL}/save`, 'POST', objetives)
    return response
  }
 
  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllIobjetives(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getAllIdentificationCompany(id,  page) {
    const response = await http(`${API_URL}/company/${id}?page=${page}`)
    return response
  } 
 
  async getRevised(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateRevisedO(id, revised) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revised)
    return response
  }
 
  async deleteIdentification(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new revised_objetivesAPI()